import React from "react";
import SubcontractorPlaceholder from "@/pages/SubcontractorPlaceholder";
import { CalendarBlank } from "@phosphor-icons/react";

export default function SubAttendance() {
  return (
    <SubcontractorPlaceholder
      title="Puantaj / Devam"
      icon={CalendarBlank}
      description="Taşeron işçi devam takibi (mavi yaka puantaj)."
    />
  );
}
